import React, { useEffect, useState } from 'react';
import { Button, Typography } from 'antd';
import { CheckCircleOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const { Title, Text } = Typography;

interface PaymentOptionsProps {
  onSelectPlan: (plan: any) => void;
  selectedReport: any;
}

const PaymentOptions: React.FC<PaymentOptionsProps> = ({
  onSelectPlan,
  selectedReport,
}) => {
  const navigate = useNavigate();

  const [pricingPlans, setPricingPlans] = useState<any[]>([]);
  const [selectedPlan, setSelectedPlan] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_INSTANCE}/api/paymentPlan`)
      .then(res => {
        setPricingPlans(res.data.paymentPlans);
      })
      .finally(() => setLoading(false));
  }, []);

  const handleSelectPlan = (plan: any) => {
    setSelectedPlan(plan);
  };

  return (
    <div style={{ paddingBottom: '2rem', textAlign: 'center' }}>
      <Title level={2}>Please select which search package you would like</Title>
      <div
        style={{
          display: 'flex',
          gap: '2rem',
          flexWrap: 'wrap',
          justifyContent: 'center',
          marginTop: '2rem',
          alignItems: 'stretch', // Ensures all items stretch to the same height
        }}
      >
        {loading ? (
          <div
            style={{
              width: '100%',
              height: '100vh',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <div className='loader'></div>
          </div>
        ) : (
          pricingPlans.map((plan: any) => (
            <Plan
              plan={plan}
              key={plan._id}
              onSelect={handleSelectPlan}
              isSelected={selectedPlan?._id === plan._id}
              onConfirm={() => onSelectPlan(plan)}
            />
          ))
        )}
      </div>
    </div>
  );
};

interface IPlan {
  plan: any;
  onSelect: (plan: any) => void;
  isSelected: boolean;
  onConfirm: () => void;
}

const Plan: React.FC<IPlan> = ({ plan, onSelect, isSelected, onConfirm }) => {
  const { title, subTitle, price, services, bestValue } = plan;

  const handleButtonClick = (e: React.MouseEvent) => {
    e.stopPropagation(); // Prevent triggering onClick for the entire plan
    if (isSelected) {
      onConfirm(); // Confirm the selected plan
    } else {
      onSelect(plan); // Select the plan
    }
  };

  return (
    <div
      className={`pricingPlan ${isSelected ? 'selected' : ''}`}
      onClick={() => onSelect(plan)}
      style={{
        border: isSelected ? '2px solid #1890ff' : '1px solid #d9d9d9',
        borderRadius: '22px',
        cursor: 'pointer',
        padding: '8px',
        display: 'flex',
        position: 'relative',
        flexDirection: 'column',
        justifyContent: 'space-between',
        // flex: '1',
        // minHeight: '400px', // Set a minimum height for consistency
        boxSizing: 'border-box',
        alignItems: 'center',
      }}
    >
      {bestValue && <div className='pricingPlan__bestValue'>Best Value</div>}
      <div className='pricingPlan__content' style={{ flex: '1 0 auto' }}>
        <div
          className='pricingPlan__upper'
          style={bestValue ? { background: '#BFE9DF' } : {}}
        >
          <h1 style={bestValue ? { color: '#6A09C4' } : {}}>{title || ''}</h1>
          <h1 style={bestValue ? { color: '#6A09C4' } : {}}>{subTitle || ''}</h1>
          {/* <h2 style={{color: 'black' }} >£{price || ''}</h2> */}
          <p> £{price || ''} </p>
          {/* <p>
            Our technology will search for your stolen item for the selected
            period
          </p> */}
          {isSelected && (
            <CheckCircleOutlined
              style={{
                color: '#1890ff',
                fontSize: '24px',
                position: 'absolute',
                top: '10px',
                right: '10px',
              }}
            />
          )}
        </div>
        <div
          className='pricingPlan__lower'
          style={bestValue ? { background: '#FEC023' } : {}}
        >
          <div className="pricingPlan__content">
            <p style={{ display: 'flex', alignItems: 'center', marginBottom: '-0.8rem' }}>
              <span style={{ marginRight: '0.5rem', }}>✔️</span>
              Seeker will search the following UK online retail platforms:
            </p>
            <div style={{ paddingLeft: '1.5rem' }}>
              <p style={{ display: 'flex', alignItems: 'center', fontSize: '0.9rem', marginRight: '0.5rem'}}>
                {/* <span style={{ marginRight: '0.5rem', color: '#6A09C4' }}>-</span> */}
                Ebay, GumTree, Preloved and Facebook Marketplace
              </p>
              </div>

              <p style={{ display: 'flex', alignItems: 'center', }}>
                <span
                  style={{
                    marginRight: '0.5rem',
                    color: title === "Essential Search" ? '#FF0000' : '#6A09C4',
                    textDecoration: 'none'
                  }}
                >
                  {title === "Essential Search" ? '❌' : '✔️'}
                </span>
                <span style={{ textDecoration: title === "Essential Search" ? 'line-through' : 'none' }}>
                  Search and alert our physical 2nd hand retail partners.
                </span>
              </p>
              <p style={{ display: 'flex', alignItems: 'center', }}>
                <span
                  style={{
                    marginRight: '0.5rem',
                    color: title === "Essential Search" ? '#FF0000' : '#6A09C4',
                    textDecoration: 'none'
                  }}
                >
                  {title === "Essential Search" ? '❌' : '✔️'}
                </span>
                <span style={{ textDecoration: title === "Essential Search" ? 'line-through' : 'none' }}>
                  Free Found Protect membership.
                </span>
              </p>

          </div>

          <Button
            type="primary"
            onClick={handleButtonClick}
            style={{
              marginTop: 'auto',
              // position: 'absolute', 
              // left: '12%', /* Center the button horizontally */
              // bottom: '10px',
              width: '80%',
              backgroundColor: isSelected ? '#6A09C4' : '#fff',
              borderColor: isSelected ? '#6A09C4' : (bestValue ? '#6A09C4' : '#fec023'),
              color: isSelected ? 'white' : '#6A09C4',
              borderRadius: '22px',
              borderWidth: '2px',  // Adjust the border width to match the image
              padding: '10px',  // Adjust the padding if needed
              boxShadow: isSelected ? '0 0 10px rgba(0, 0, 0, 0.1)' : 'none', // Optional: Add shadow when selected
            }}
          >
            {isSelected ? 'Confirm Selected' : 'Select'}
          </Button>
        </div>
      </div>

    </div>
  );
};

export default PaymentOptions;
